// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IPlaceOrderResponseModel {
    static getAttributeTypeMap() {
        return IPlaceOrderResponseModel.attributeTypeMap;
    }
}
IPlaceOrderResponseModel.discriminator = undefined;
IPlaceOrderResponseModel.attributeTypeMap = [
    {
        "name": "orderId",
        "baseName": "orderId",
        "type": "number"
    },
    {
        "name": "orderStatusId",
        "baseName": "orderStatusId",
        "type": "number"
    },
    {
        "name": "orderStatusDescription",
        "baseName": "orderStatusDescription",
        "type": "string"
    },
    {
        "name": "carrier",
        "baseName": "carrier",
        "type": "string"
    },
    {
        "name": "trackingNumber",
        "baseName": "trackingNumber",
        "type": "string"
    },
    {
        "name": "dateShipped",
        "baseName": "dateShipped",
        "type": "Date"
    }
];
//# sourceMappingURL=iPlaceOrderResponseModel.js.map